import React from "react";
import ProductCard from "./ProductCard";
import { ImprovedProduct } from "../../Interfaces/Product";
import { ImprovedParticipantShop } from "../../Interfaces/FundraiserRole";
import PaginationControls from "./PaginationControls";

interface ProductCardGridProps {
  paginatedProducts: ImprovedProduct[];
  participantShop: ImprovedParticipantShop;
  totalProductPages: number;
  currentPage: number;
  isFromSamplePage?: boolean;
  setCurrentPage: (page: number) => void;
}

const ProductCardGrid: React.FC<ProductCardGridProps> = ({
  paginatedProducts,
  participantShop,
  totalProductPages,
  currentPage,
  setCurrentPage,
  isFromSamplePage = false,
}) => {
  return (
    <>
      <div className="row g-4 w-100 m-0">
        {paginatedProducts.map((product) => (
          <div
            className="product-card-div col-12 col-md-6 col-lg-4 col-xl-3"
            key={product.sku}
          >
            <ProductCard
              product={product}
              participantID={String(
                participantShop.participant.participant_code || "",
              )}
              shopInfo={participantShop}
              isFromSamplePage={isFromSamplePage}
            />
          </div>
        ))}
      </div>
      {totalProductPages > 1 && (
        <PaginationControls
          currentPage={currentPage}
          totalPages={totalProductPages}
          onPageChange={setCurrentPage}
          className="mt-4"
        />
      )}
    </>
  );
};

export default ProductCardGrid;
